export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/0c7f90dcab4574f291a5b93f31621815.svg";